import LFCButton from '_components/inputs/LFCButton';
import ProgressBar from '_components/ProgressBar';
import {deleteDeviceHistory} from '_logics/LFCDeviceInfoUtil';
import {useSnackbar} from 'notistack';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';

type DeleteHistoryDialogProps = {
  open: boolean;
  deviceName: string;
  onClose: () => void;
  onDeleted: () => void;
};

const DeleteHistoryDialog = ({open, deviceName, onClose, onDeleted}: DeleteHistoryDialogProps) => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const [deleting, setDeleting] = useState(false);

  const handleDelete = () => {
    setDeleting(true);
    deleteDeviceHistory({snack: enqueueSnackbar, t, deviceName})
      .then(() => onDeleted())
      .catch(() => {})
      .finally(() => setDeleting(false));
  };

  return (
    <>
      <ProgressBar startProcess={deleting} screenLock />
      <Dialog open={open} onClose={deleting ? undefined : onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{t('履歴データ削除')}</DialogTitle>
        <DialogContent>
          <DialogContentText>{t('履歴データを削除しますか', {deviceName})}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <LFCButton onClick={onClose} disabled={deleting}>
            {t('キャンセル')}
          </LFCButton>
          <LFCButton onClick={handleDelete} disabled={deleting} color="error">
            {t('削除する')}
          </LFCButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DeleteHistoryDialog;
